/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurveyShape } from './DataSurveyShape';
import {
    DataSurveyShapeFromJSON,
    DataSurveyShapeFromJSONTyped,
    DataSurveyShapeToJSON,
    DataSurveyShapeToJSONTyped,
} from './DataSurveyShape';
import type { DataSurveyTypeEnum } from './DataSurveyTypeEnum';
import {
    DataSurveyTypeEnumFromJSON,
    DataSurveyTypeEnumFromJSONTyped,
    DataSurveyTypeEnumToJSON,
    DataSurveyTypeEnumToJSONTyped,
} from './DataSurveyTypeEnum';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Full serializer for `DataSurvey` records.
 * @export
 * @interface DataSurveyData
 */
export interface DataSurveyData {
    /**
     * 
     * @type {string}
     * @memberof DataSurveyData
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof DataSurveyData
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof DataSurveyData
     */
    startDatetime: Date;
    /**
     * 
     * @type {Date}
     * @memberof DataSurveyData
     */
    endDatetime: Date;
    /**
     * 
     * @type {DataSurveyTypeEnum}
     * @memberof DataSurveyData
     */
    dataType: DataSurveyTypeEnum;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof DataSurveyData
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {DataSurveyShape}
     * @memberof DataSurveyData
     */
    shape?: DataSurveyShape | null;
    /**
     * 
     * @type {any}
     * @memberof DataSurveyData
     */
    metadata?: any | null;
    /**
     * 
     * @type {any}
     * @memberof DataSurveyData
     */
    surveyData?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof DataSurveyData
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DataSurveyData
     */
    readonly updatedAt: Date | null;
}



/**
 * Check if a given object implements the DataSurveyData interface.
 */
export function instanceOfDataSurveyData(value: object): value is DataSurveyData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('startDatetime' in (value as Record<string, any>)) && !('start_datetime' in (value as Record<string, any>))) || ((value as Record<string, any>)['startDatetime'] === undefined && (value as Record<string, any>)['start_datetime'] === undefined)) return false;
    if ((!('endDatetime' in (value as Record<string, any>)) && !('end_datetime' in (value as Record<string, any>))) || ((value as Record<string, any>)['endDatetime'] === undefined && (value as Record<string, any>)['end_datetime'] === undefined)) return false;
    if ((!('dataType' in (value as Record<string, any>)) && !('data_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataType'] === undefined && (value as Record<string, any>)['data_type'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function DataSurveyDataFromJSON(json: any): DataSurveyData {
    return DataSurveyDataFromJSONTyped(json, false);
}

export function DataSurveyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSurveyData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDatetime': (new Date(json['start_datetime'])),
        'endDatetime': (new Date(json['end_datetime'])),
        'dataType': DataSurveyTypeEnumFromJSON(json['data_type']),
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'shape': json['shape'] === undefined ? undefined : json['shape'] === null ? null : DataSurveyShapeFromJSON(json['shape']),
        'metadata': json['metadata'] === undefined ? undefined : json['metadata'] === null ? null : json['metadata'],
        'surveyData': json['survey_data'] === undefined ? undefined : json['survey_data'] === null ? null : json['survey_data'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function DataSurveyDataToJSON(json: any): DataSurveyData {
    return DataSurveyDataToJSONTyped(json, false);
}

export function DataSurveyDataToJSONTyped(value?: Omit<DataSurveyData, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'start_datetime': value['startDatetime'].toISOString(),
        'end_datetime': value['endDatetime'].toISOString(),
        'data_type': DataSurveyTypeEnumToJSON(value['dataType']),
        'location': DataPointHistoryLocationToJSON(value['location']),
        'shape': DataSurveyShapeToJSON(value['shape']),
        'metadata': value['metadata'],
        'survey_data': value['surveyData'],
    };
}

